<template>
  <b-media class="boon-notification">
    <template #aside>
      <b-avatar
        class="ml-2 initials"
        :text="avatarText"
        :badge="lastCommentReadDateAtLogin < comment.commentdate ? 'new' : null"
      />
    </template>
    <router-link
      v-close-popover
      :to="{ name: 'ProjectPlanPart', params: { _id: comment.projectId, partId: comment.partId } }"
      target="_blank"
      class="textContainer"
    >
      <div>
        <p class="mt-0 mb-1" v-html="comment.text" />
        <p class="mt-0 mb-0 partTitle">
          <strong class="font-weight-bold">{{ comment.title }}</strong>
          <span v-if="project">- {{ project.projectNumber }} {{ project.title }}</span>
        </p>
        <p class="mt-0 mb-0 author">
          {{ personName(comment.authorPersonId) || comment.authorUsername }} /
          {{ commentdate(comment.commentdate) }}
        </p>
      </div>
    </router-link>
  </b-media>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { recentFuzzytime } from '@/common/timeHelpers';

export default {
  name: 'HeaderComment',
  data() {
    return {
      part: {},
    };
  },
  props: ['comment'],
  components: {},
  methods: {
    ...mapActions(['getPart']),
    commentdate: function (date) {
      return this.$t(recentFuzzytime(date));
    },
  },
  computed: {
    ...mapGetters(['fetchPart', 'getPerson', 'getProject', 'lastCommentReadDateAtLogin', 'personName']),
    project() {
      return this.getProject(this.comment.projectId);
    },
    person: function () {
      return this.getPerson(this.comment.authorPersonId);
    },
    avatarText: function () {
      return (this.person.firstName.substring(0, 1) + this.person.lastName.substring(0, 1)).toUpperCase();
    },
  },
  mounted() {},
};
</script>

<style scoped>
h1 {
  font-size: 0.8rem;
}
.boon-notification {
  text-transform: initial;
}
.partTitle,
.author {
  font-size: 0.7rem;
}
.author {
  color: gray;
}

.initials {
  background-color: #2e8ab2;
  color: white;
}
</style>

<style>
.boon-notification > .media-body {
  width: 100%;
}

.tag {
  color: #e8963a;
  font-style: normal;
}
.b-avatar-badge {
  background-color: #e8963a;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/HeaderComment.vue